// NOMBASE — Sidebar nav data, kept as plain JS so the regression suite
// can import it without pulling react-router-dom / Clerk / the full
// AppShell tree through Jest's resolver. The `icon` references are
// react components from lucide-react, which is safe in Jest because
// they're tree-shaken to identifiers; we never *render* them in tests.
//
// AppShell.jsx re-exports these so existing import sites
// (`import { brandNavItems } from '@/components/layout/AppShell'`)
// continue to work.
import {
  LayoutDashboard,
  Building2,
  Package,
  CalendarRange,
  Send,
  FolderClosed,
  Compass,
} from 'lucide-react';

// Brand Navigation Items — the entire sidebar in the brand-only MVP.
// `home` is pinned (renders as the fixed top icon) and never appears
// in the customizable middle list. Every other entry is draggable-
// reorderable and can be removed via the little × on hover.
//
// MVP gating contract:
//   The brand sidebar contains the core workflow surfaces — Home /
//   Network / Product / Plan / Buy / Documents. No
//   Requests, Orders, Customers, Pipeline, Scorecard, Shipments, or
//   Catalog labels are allowed here.
//
// ``core: true`` marks an item as *un-removable* by the user. Core
// items are still drag-reorderable, but the small × hover button
// is suppressed and `useSidebarConfig.remove(id)` is a no-op for
// them. This prevents the production support pattern "I clicked
// the Buy icon and it disappeared" — a click that lands on the
// hover × removes the only navigation surface for that page.
export const brandNavItems = [
  { id: 'home',    label: 'Home',    href: '/',        iconName: 'LayoutDashboard', icon: LayoutDashboard, fixed: true, core: true },
  { id: 'network', label: 'Network', href: '/network', iconName: 'Building2',       icon: Building2,       core: true },
  { id: 'product', label: 'Product', href: '/products', iconName: 'Package',         icon: Package,         core: true },
  { id: 'plan',    label: 'Plan',    href: '/plan',    iconName: 'CalendarRange',   icon: CalendarRange,   core: true },
  { id: 'buy',     label: 'Buy',     href: '/buy',     iconName: 'Send',            icon: Send,            core: true },
  { id: 'demand',  label: 'Demand',  href: '/demand',  iconName: 'Compass',         icon: Compass,         core: true },
  { id: 'documents', label: 'Documents', href: '/documents', iconName: 'FolderClosed', icon: FolderClosed, core: true },
];

/**
 * Legacy supplier-nav builder. Kept as a no-op shim so any stale
 * callsite that still calls `getSupplierNavItems(tenantType)` keeps
 * compiling and just returns the brand nav. In the brand-only MVP
 * every user IS a brand, so this is the correct fallback.
 *
 * This shim should be deleted once no callsite references it
 * (currently AppShell.jsx still does — see
 * `frontend/src/components/layout/AppShell.jsx`).
 */
export const getSupplierNavItems = () => brandNavItems;
